module.exports = __webpack_public_path__ + "img/apidays-live-hongkong-2021-agenda-825.b7f9fdcf.png";